import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
interface TopStudentAttribute {
    studentName: String;
    totalScore: number;
    time: String;
    index: number;
}
const GoldMedal = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <circle cx='12' cy='12' r='12' fill='#FFCA28' />
        <path
            d='M9.91622 23.8177C12.0957 24.202 14.3389 23.9761 16.398 23.165C18.4571 22.3539 20.2518 20.9892 21.5836 19.2218C22.9155 17.4543 23.7326 15.353 23.9448 13.1501C24.1569 10.9473 23.7557 8.72864 22.7855 6.73955L12 12L9.91622 23.8177Z'
            fill='#FFA000'
        />
        <path d='M8.69235 0.464859C6.87199 0.98684 5.20101 1.93224 3.81602 3.22375C2.43104 4.51527 1.37138 6.11623 0.723692 7.89575L12 12L8.69235 0.464859Z' fill='#FFECB3' />
        <path d='M5.11708 2.17017C4.08559 2.89244 3.1742 3.77255 2.41638 4.77821L12 12L5.11708 2.17017Z' fill='#FFF8E1' />
        <circle cx='12.0003' cy='12' r='8.83333' fill='#FFB300' stroke='#FFA000' />
        <path d='M13.2262 7.33337V16.8451H11.6572V9.19535L9.33301 9.98311V8.68754L13.0374 7.33337H13.2262Z' fill='#FFECB3' />
    </svg>
);

const SilverMedal = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <circle cx='12' cy='12' r='12' fill='#78909C' />
        <path
            d='M9.91622 23.8177C12.0957 24.202 14.3389 23.9761 16.398 23.165C18.4571 22.3539 20.2518 20.9892 21.5836 19.2218C22.9155 17.4543 23.7326 15.353 23.9448 13.1501C24.1569 10.9473 23.7557 8.72864 22.7855 6.73955L12 12L9.91622 23.8177Z'
            fill='#455A64'
        />
        <path d='M8.69235 0.464859C6.87199 0.98684 5.20101 1.93224 3.81602 3.22375C2.43104 4.51527 1.37138 6.11623 0.723692 7.89575L12 12L8.69235 0.464859Z' fill='#CFD8DC' />
        <path d='M5.11708 2.17017C4.08559 2.89244 3.1742 3.77255 2.41638 4.77821L12 12L5.11708 2.17017Z' fill='#ECEFF1' />
        <circle cx='12.0003' cy='12' r='8.83333' fill='#546E7A' stroke='#455A64' />
        <path
            d='M15.2035 15.4166V16.6666H8.84928V15.5924L11.9352 12.2265C12.2738 11.8446 12.5407 11.5147 12.736 11.2369C12.9313 10.9592 13.068 10.7096 13.1462 10.4882C13.2286 10.2625 13.2699 10.0434 13.2699 9.83069C13.2699 9.53121 13.2134 9.26862 13.1006 9.04293C12.9921 8.81289 12.8315 8.63277 12.6188 8.50256C12.4061 8.36801 12.1479 8.30074 11.8441 8.30074C11.4925 8.30074 11.1974 8.3767 10.9587 8.52861C10.7199 8.68051 10.5398 8.89102 10.4183 9.16012C10.2968 9.42487 10.236 9.72869 10.236 10.0716H8.66699C8.66699 9.52036 8.79286 9.01689 9.0446 8.56116C9.29633 8.10109 9.66092 7.7365 10.1383 7.46741C10.6158 7.19397 11.1909 7.05725 11.8636 7.05725C12.4973 7.05725 13.0355 7.16359 13.4782 7.37626C13.9209 7.58894 14.2573 7.89058 14.4873 8.28121C14.7217 8.67183 14.8389 9.13407 14.8389 9.66793C14.8389 9.96307 14.7911 10.256 14.6956 10.5468C14.6002 10.8376 14.4634 11.1284 14.2855 11.4192C14.1119 11.7057 13.9057 11.9943 13.667 12.2851C13.4283 12.5716 13.1657 12.8624 12.8792 13.1575L10.8285 15.4166H15.2035Z'
            fill='#CFD8DC'
        />
    </svg>
);

const BronzeMedal = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <circle cx='12' cy='12' r='12' fill='#CF9528' />
        <path
            d='M9.91622 23.8177C12.0957 24.202 14.3389 23.9761 16.398 23.165C18.4571 22.3539 20.2518 20.9892 21.5836 19.2218C22.9155 17.4543 23.7326 15.353 23.9448 13.1501C24.1569 10.9473 23.7557 8.72864 22.7855 6.73955L12 12L9.91622 23.8177Z'
            fill='#8B6424'
        />
        <path d='M8.69235 0.464859C6.87199 0.98684 5.20101 1.93224 3.81602 3.22375C2.43104 4.51527 1.37138 6.11623 0.723692 7.89575L12 12L8.69235 0.464859Z' fill='#FBDCA5' />
        <path d='M5.11708 2.17017C4.08559 2.89244 3.1742 3.77255 2.41638 4.77821L12 12L5.11708 2.17017Z' fill='#FAE6C2' />
        <circle cx='12.0003' cy='12' r='8.83333' fill='#AB7B27' stroke='#8B6424' />
        <path
            d='M10.7178 11.2174H11.6553C12.0199 11.2174 12.3215 11.1545 12.5602 11.0286C12.8033 10.9027 12.9834 10.7291 13.1006 10.5078C13.2178 10.2864 13.2764 10.0325 13.2764 9.74605C13.2764 9.44657 13.2221 9.1905 13.1136 8.97782C13.0094 8.76081 12.8488 8.59371 12.6318 8.47652C12.4192 8.35933 12.1479 8.30074 11.818 8.30074C11.5403 8.30074 11.2885 8.35716 11.0628 8.47001C10.8415 8.57852 10.6657 8.73477 10.5355 8.93876C10.4053 9.13841 10.3402 9.37713 10.3402 9.65491H8.76465C8.76465 9.15143 8.89703 8.70439 9.16178 8.31376C9.42654 7.92314 9.78678 7.61715 10.2425 7.39579C10.7026 7.1701 11.2191 7.05725 11.792 7.05725C12.404 7.05725 12.9378 7.15925 13.3936 7.36324C13.8536 7.56289 14.2117 7.86237 14.4678 8.26168C14.7239 8.66098 14.8519 9.15578 14.8519 9.74605C14.8519 10.0152 14.789 10.2886 14.6631 10.5664C14.5372 10.8441 14.3506 11.098 14.1032 11.3281C13.8558 11.5538 13.5476 11.7382 13.1787 11.8815C12.8098 12.0204 12.3823 12.0898 11.8962 12.0898H10.7178V11.2174ZM10.7178 12.4414V11.582H11.8962C12.4517 11.582 12.9248 11.6471 13.3154 11.7773C13.7104 11.9075 14.0316 12.0876 14.279 12.3177C14.5264 12.5434 14.7065 12.8016 14.8193 13.0924C14.9365 13.3832 14.9951 13.6914 14.9951 14.0169C14.9951 14.4596 14.9148 14.8546 14.7542 15.2018C14.598 15.5447 14.3745 15.8355 14.0837 16.0742C13.7929 16.3129 13.4521 16.493 13.0615 16.6145C12.6752 16.7361 12.2542 16.7968 11.7985 16.7968C11.3905 16.7968 10.9999 16.7404 10.6266 16.6276C10.2534 16.5147 9.91916 16.3476 9.62402 16.1263C9.32888 15.9006 9.09451 15.6206 8.9209 15.2864C8.75163 14.9479 8.66699 14.5573 8.66699 14.1145H10.236C10.236 14.3967 10.3011 14.6462 10.4313 14.8632C10.5659 15.0759 10.7525 15.243 10.9912 15.3645C11.2343 15.4861 11.512 15.5468 11.8245 15.5468C12.1544 15.5468 12.4387 15.4882 12.6774 15.3711C12.9161 15.2539 13.0984 15.0803 13.2243 14.8502C13.3545 14.6202 13.4196 14.3424 13.4196 14.0169C13.4196 13.648 13.348 13.3485 13.2048 13.1184C13.0615 12.8884 12.8575 12.7191 12.5928 12.6106C12.328 12.4978 12.0155 12.4414 11.6553 12.4414H10.7178Z'
            fill='#FBDCA5'
        />
    </svg>
);
const TopStudentPerformanceCard = (props: TopStudentAttribute) => {
    const { t } = useTranslation();

    return (
        <Card
            sx={{
                display: 'inline-flex',
                padding: '8px 0px',
                height: '100%',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'flex-start',
            }}>
            <Card
                sx={{
                    display: 'flex',
                    gap: '8px',
                    padding: '8px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    flex: '1 0 0',
                    height: '100%',
                    boxShadow: 'none',
                }}>
                <Typography style={{ color: '#533D18' }} fontSize={16} fontWeight={400} lineHeight='24px' variant='body1'>
                    {t('resultPage.studentName') + '：' + props.studentName}
                </Typography>
                <br></br>
                <Typography style={{ color: '#533D18' }} fontSize={16} fontWeight={400} lineHeight='24px' variant='body1'>
                    {t('resultPage.score') + '：' + +props.totalScore}
                </Typography>
                <Typography style={{ color: '#533D18' }} fontSize={16} fontWeight={400} lineHeight='24px' variant='body1'>
                    {t('resultPage.totalAnswerTime') + '：' + props.time}
                </Typography>
            </Card>
            <Box
                sx={{
                    display: 'flex',
                    padding: '10px',
                    paddingRight: '15px',
                    gap: '16px',
                    alignItems: 'center',
                }}>
                {props.index === 1 && <GoldMedal />}
                {props.index === 2 && <SilverMedal />}
                {props.index === 3 && <BronzeMedal />}
            </Box>
        </Card>
    );
};

export default TopStudentPerformanceCard;
